import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter} from 'react-router-dom';
 
import Routes from './Routes';

ReactDOM.render(<BrowserRouter  basename={window.Basename}>
    <Routes />
</BrowserRouter>, document.getElementById('root')); 



// WEBPACK FOOTER //
// ./src/index.js